import { Action } from 'redux';

import { ListResult } from '../../../ts/fetchers/ListResult';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { IRange } from '../../../ts/models/IRange';
import {
  SpaceContentsMissingSliceRequest,
  SpaceContentsRequest,
  SpaceContentsRequestFailed,
  SpaceContentsRequestSucceeded,
  SpaceContentsSliceSucceeded,
} from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface SpaceContentsRequestAction extends Action {}

export function requestSpaceContents(): SpaceContentsRequestAction {
  return {
    type: SpaceContentsRequest
  };
}

export const isSpaceContentsRequestAction = isActionFactory<SpaceContentsRequestAction>(SpaceContentsRequest);

//-------------------------

export interface SpaceContentsRequestSucceededAction extends Action {
  readonly content: ListResult<IContentInfo>;
}

export function spaceContentsRequestSucceeded(content: ListResult<IContentInfo>): SpaceContentsRequestSucceededAction {
  return {
    type: SpaceContentsRequestSucceeded,
    content
  };
}

export const isSpaceContentsRequestSucceededAction = isActionFactory<SpaceContentsRequestSucceededAction>(SpaceContentsRequestSucceeded);

//-------------------------

export interface SpaceContentsRequestFailedAction extends Action {}

export function spaceContentsRequestFailed(): SpaceContentsRequestFailedAction {
  return {
    type: SpaceContentsRequestFailed
  };
}

export const isSpaceContentsRequestFailedAction = isActionFactory<SpaceContentsRequestFailedAction>(SpaceContentsRequestFailed);

//-------------------------

export interface SpaceContentsMissingSliceRequestAction extends Action, IRange {}

// From start (inclusive) to end (exclusive)
export function requestSpaceContentsMissingSlice(start: number, end: number): SpaceContentsMissingSliceRequestAction {
  return {
    type: SpaceContentsMissingSliceRequest,
    start: start,
    end: end
  };
}

export const isSpaceContentsMissingSliceRequestAction = isActionFactory<SpaceContentsMissingSliceRequestAction>(SpaceContentsMissingSliceRequest);

//-------------------------

export interface SpaceContentsSliceSucceededAction extends Action {
  start: number;
  content: ListResult<IContentInfo>;
}

export function spaceContentsSliceSucceeded(start: number, content: ListResult<IContentInfo>): SpaceContentsSliceSucceededAction {
  return {
    type: SpaceContentsSliceSucceeded,
    start,
    content
  };
}

export const isSpaceContentsSliceSucceededAction = isActionFactory<SpaceContentsSliceSucceededAction>(SpaceContentsSliceSucceeded);
